/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import styled from "styled-components";
import { IoClose } from "react-icons/io5";
import qrCode from "../../assets/icons/qr-code.png";
import fipayFonts from "../../theme/index";

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 12px;
  text-align: center;
  width: 350px;
  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;

const QrCodeImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const QrCodeImage = styled.img`
  width: 150px;
  height: 150px;
  margin-top: 20px;
`;
const QrTopContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  border-radius: 12px 12px 0px 0px;
  background-color: #ceccde;
`;
const QrX = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  background-color: #fff;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
`;
const QrP = styled.p`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.bold};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
`;

const QrS = styled.span`
  font-family: GT Walsheim Pro;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  text-align: left;
  color: #8c8b8b;
`;

const QrButton = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  padding: 15px;
  border-radius: 0.625rem;
  @media only screen and (max-width: 767px) {
    flex-direction: column;
    width: 100%;
    padding: 1.5rem 0;
    align-items: center;
    align-self: center;
  }
`;

const QrScanButton = styled.button`
  background-color: transparent;
  color: #afafaf;
  padding: 10px 20px;
  border: none;
  border-radius: 0.625rem;
  border: 1px solid var(--Neutral-Neutral-400, #afafaf);
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;
const QrCancelButton = styled.button`
  background-color: #00a603;
  color: #fff;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    width: 90%;
  }
`;

const qrcode = ({ onCancel }: { onCancel: () => void }) => {
  const [isModalVisible, setIsModalVisible] = useState(true);
  const [isCopied, setIsCopied] = useState(false);
  const handleCloseModal = () => {
    setIsModalVisible(false);
  };

  const handleCopyToClipboard = () => {
    const qrCodeImageSrc = "/assets/icons/qr-code.png";
    navigator.clipboard.writeText(qrCodeImageSrc);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const handleDownloadImage = () => {
    const downloadLink = document.createElement("a");
    downloadLink.href = "/assets/icons/qr-code.png";
    downloadLink.download = "qr_code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    onCancel();
  };
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      setIsModalVisible(false);
      onCancel();
    }
  };
  return (
    <ModalWrapper
      style={{ display: isModalVisible ? "flex" : "none" }}
      onClick={handleModalClick}
    >
      <ModalContent>
        <QrTopContent>
          <div>
            <QrP>Your QR Code</QrP>
            <QrS>Scan to pay</QrS>
          </div>
          <QrX onClick={handleCloseModal}>
            <IoClose />
          </QrX>
        </QrTopContent>
        <QrCodeImageDiv>
          <QrCodeImage src="/assets/icons/qr-code.png" alt="QR Code" />
          <QrP>Scan to pay</QrP>
        </QrCodeImageDiv>

        <QrButton>
          <QrScanButton onClick={handleCopyToClipboard}>
            {" "}
            {isCopied ? "Link Copied!" : "Copy to clipboard"}
          </QrScanButton>
          <QrCancelButton onClick={handleDownloadImage}>
            Download Image
          </QrCancelButton>
        </QrButton>
      </ModalContent>
    </ModalWrapper>
  );
};

export default qrcode;
